
import Vue from 'vue';

export default Vue.extend({
	props: {
		modalName: { type: String, default: 'Modal' },
		modalSize: { type: String, default: 'md' },
		hideHeader: { type: Boolean, default: false },
		hideFooter: { type: Boolean, default: false },
	},
	methods: {
		showModal(): void {
			this.$emit('showModal');
		},
		hideModal(): void {
			this.$emit('hideModal');
		},
		hide(): void {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			(this.$refs.modal as any).hide();
		},
		show(): void {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			(this.$refs.modal as any).show();
		},
	},
});
